var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JdsLink',{attrs:{"type":"button","className":"sm:fe-text-body-xxs-link lg:fe-text-body-xs-link"},on:{"click":_vm.toggleText}},[_vm._v(" "+_vm._s(_vm.isExpanded ? "Read less" : "Read more")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }